import React__default, { memo, useEffect } from 'react';
import SelectProposal from './steps/SelectProposal.esm.js';
import SelectClient from './steps/SelectClient.esm.js';
import { useProposalContext } from './proposalContext.esm.js';
import { DialogPortal, DialogOverlay } from '../ui/dialog.esm.js';
import CSSTransition from '../../node_modules/react-transition-group/esm/CSSTransition.esm.js';

const initialForm = {
  genderType: "",
  firstName: "",
  lastName: ""
};
const Proposal = () => {
  const {
    state,
    dispatch,
    isOpen,
    offerData,
    source,
    closeProposal
  } = useProposalContext();
  const {
    step
  } = state;
  const [form, setForm] = React__default.useState(initialForm);
  const [selectedClient, setSelectedClient] = React__default.useState(null);
  useEffect(() => {
    if (isOpen && offerData) {
      dispatch({
        type: 'SET_STEP',
        payload: 'selectProposal'
      });
      dispatch({
        type: 'SET_SELECTED_PROPOSAL',
        payload: null
      });
      setSelectedClient(null);
      setForm(initialForm);
      document.dispatchEvent(new CustomEvent('travelyo:hf', {
        detail: {
          name: 'Results card add to proposal clicked',
          data: {
            offerData,
            source
          }
        }
      }));
    }
  }, [isOpen, offerData, dispatch, source]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-dialog"
  }, /*#__PURE__*/React__default.createElement(DialogPortal, null, /*#__PURE__*/React__default.createElement(CSSTransition, {
    in: isOpen,
    timeout: 300,
    classNames: "hf-modal-animate",
    unmountOnExit: true,
    mountOnEnter: true
  }, /*#__PURE__*/React__default.createElement(DialogOverlay, null, offerData && (/*#__PURE__*/React__default.createElement("div", {
    className: "voyage-dialog__content modal-body proposal-dialog"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: closeProposal,
    className: "voyage-dialog__close"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "ri-close-line text-xl text-shark-400"
  })), step === 'selectProposal' && /*#__PURE__*/React__default.createElement(SelectProposal, {
    date: offerData.date,
    offerData: offerData,
    source: source
  }), step === 'selectClient' && (/*#__PURE__*/React__default.createElement(SelectClient, {
    form: form,
    onChangeForm: setForm,
    selectedClient: selectedClient,
    onSelectClient: setSelectedClient,
    offerData: offerData,
    source: source
  }))))))));
};
var Proposal$1 = /*#__PURE__*/memo(Proposal);

export { Proposal$1 as default };
//# sourceMappingURL=Proposal.esm.js.map
